import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getApprovalsRequests = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/approvals`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Approval requests fetch error:", error);
    throw error;
  }
};

const getApprovalById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/approvals?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Approval fetch error:", error);
    throw error;
  }
};

const rejectApproval = async (id, auditNotes) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/approvals/reject/?id=${id}`,
      { audit_notes: auditNotes },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Approval reject error:", error);
    throw error;
  }
};

const approveApproval = async (id, auditNotes) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/approvals/approve/?id=${id}`,
      { audit_notes: auditNotes },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Approval approve error:", error);
    throw error;
  }
};

const requestRevision = async (id, auditNotes) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/approvals/request-revision/?id=${id}`,
      { audit_notes: auditNotes },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Approval request-revision error:", error);
    throw error;
  }
};

const updateTransactionAdjustmentStatus = async (id, status) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/transaction-adjustments/?id=${id}`,
      { status },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Transaction adjustment status update error:", error);
    throw error;
  }
};

export {
  getApprovalsRequests,
  getApprovalById,
  rejectApproval,
  approveApproval,
  requestRevision,
  updateTransactionAdjustmentStatus,
};
